import Element from '../../components/element';
import React from 'react';
import Modal from '../modal';
import { colors } from '../../config/theme';
import PrivacyPolicy from '../../components/PrivacyPolicy/index';
import TermsOfService from '../../components/TermsOfService/index';

const PrivacyModal = ({ onClose, isPrivacy }) => {
  return (
    <Modal
      headerLabel={isPrivacy ? 'Privacy Policy' : 'Terms of Service'}
      closable
      shouldCloseOnOverlayClick
      preventScroll
      onClose={onClose}
      height={isPrivacy ? '80%' : '50%'}
    >
      <div>{isPrivacy ? <PrivacyPolicy /> : <TermsOfService />}</div>
      <Element
        position="sticky"
        bottom="-20px"
        backgroundColor={colors.white}
        height="100px"
        padding="25px 0"
      >
        <button onClick={onClose}>Close</button>
      </Element>
    </Modal>
  );
};

export default PrivacyModal;
